import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { API } from '../App';
import { useT } from '../i18n';
import { fetchBillingStatus, peekBillingStatus } from '../lib/billingFlow';

/*
  Trial banner on every page (plan, stage 2): from day one the client sees
  when the card is charged, how much, and that without payment the links
  stop. Shown only during a Stripe trial.
*/

export default function TrialBanner() {
  const { t } = useT();
  const [status, setStatus] = useState(() => peekBillingStatus());

  useEffect(() => {
    let alive = true;
    Promise.resolve(fetchBillingStatus(API))
      .then((s) => {
        if (alive && s) setStatus(s);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  const sub = (status && status.subscription) || {};
  const ends = sub.trial_ends_at ? new Date(sub.trial_ends_at) : null;
  if (
    !status ||
    !status.enabled ||
    !status.state ||
    status.state.status !== 'trialing' ||
    !sub.stripe_subscription_id ||
    !ends ||
    Number.isNaN(ends.getTime())
  ) {
    return null;
  }
  const days = Math.max(0, Math.ceil((ends.getTime() - Date.now()) / 86400000));
  const n = Number(status.first_charge_usd ?? (status.plan && status.plan.monthly_usd) ?? 0) || 0;
  const amount = `$${Number.isInteger(n) ? n : n.toFixed(2)}`;
  const urgent = days <= 2;

  return (
    <div
      className={`mx-4 mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 rounded-md border px-3 py-2 text-sm ${
        urgent ? 'border-amber-500/40 bg-amber-500/10' : 'border-border bg-card'
      }`}
      data-testid="trial-banner"
    >
      <Clock className="h-4 w-4 shrink-0 text-muted-foreground" />
      <span>
        {t('Trial until {date} ({days} days left). On that day your card will be charged {amount}.', {
          date: ends.toLocaleDateString(),
          days,
          amount,
        })}
      </span>
      <span className="text-muted-foreground">{t('Without payment, campaigns turn off and links stop opening.')}</span>
      <Link to="/billing" className="underline hover:text-foreground">
        {t('Billing')}
      </Link>
    </div>
  );
}
